export default __webpack_public_path__ + "static/media/stainedglasswindow.69bc8439.png";